import {MithrilComponent} from '@bitstillery/mithril'
import {Button} from '@bitstillery/common/components'
import {$t} from '@bitstillery/common/app'
import {store} from '@bitstillery/common/app'
import m from '@bitstillery/mithril'

import type {CollectionProxy} from '@bitstillery/common/lib/collection'

export interface CollectionViewToggleAttrs {
    collection: CollectionProxy
    /** Optional hook (e.g. portal `$s.shop`) when grid/list changes; runs before `store.save()`. */
    on_mode_change?: (mode: 'grid' | 'list') => void
}

export class CollectionViewToggle extends MithrilComponent<CollectionViewToggleAttrs> {
    view(vnode: m.Vnode<CollectionViewToggleAttrs>) {
        const {collection, on_mode_change} = vnode.attrs
        // Every layout gets the toggle: mobile used to be forced to list mode (and hid this
        // control) back when a phone-width grid meant one giant card per row; the grid is 2-up
        // on phones now.
        const mode = collection.state.view.mode
        return (
            <Button
                icon={mode === 'list' ? 'list' : 'grid'}
                onclick={() => {
                    const next: 'grid' | 'list' = mode === 'list' ? 'grid' : 'list'
                    collection.state.view.mode = next
                    on_mode_change?.(next)
                    void store.save()
                }}
                tip={() => {
                    if (mode === 'list') {
                        return $t('view.grid_switch')
                    }
                    return $t('view.list_switch')
                }}
                type='info'
                variant='toggle'
            />
        )
    }
}
